import { translate as t } from '@thoughtspot/i18n';
/**
 * Returns the year range string (e.g., "2017 - 2028") for the year picker header.
 * Each range spans 12 years, starting at years where year % 12 === 1.
 */
export const getYearsPickerRangeStart = (date) => {
    const dateYear = date.getFullYear();
    const rangeStart = dateYear - ((dateYear - 1) % 12);
    return `${rangeStart} - ${rangeStart + 11}`;
};
export const getArialLabelForArrowButtons = (isLeftArrowButton, showMonthPicker, showYearPicker) => {
    let ariaLabel = `${t('navigate_to_the')} `;
    if (isLeftArrowButton) {
        ariaLabel += `${t('previous')} `;
    }
    else {
        ariaLabel += `${t('next')} `;
    }
    if (showMonthPicker) {
        ariaLabel += t('year');
    }
    else if (showYearPicker) {
        ariaLabel += t('years');
    }
    else {
        ariaLabel += t('month');
    }
    return ariaLabel;
};
//# sourceMappingURL=date-picker.util.js.map